import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { QRCodeSettings } from "@app-cmc/models";
import { CFSConnectionService } from "@app-cmc/services";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { WidgetService } from "@app-cmc/services";

@Component({
  selector: "app-qr-code-full-preview-modal",
  templateUrl: "./qr-code-full-preview-modal.component.html",
  styleUrls: ["./qr-code-full-preview-modal.component.scss"]
})
export class QrCodeFullPreviewModalComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    public activeModal: NgbActiveModal,
    private cfsConnectionService: CFSConnectionService,
    private changeDetectorRef: ChangeDetectorRef,
    private widgetService: WidgetService
  ) {}

  private unsubscribe$ = new Subject<void>();

  @Input() settings: QRCodeSettings;

  ngOnInit(): void {
    this.cfsConnectionService.showQrCodeModal(this.settings.sessionId);
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  dismiss() {
    this.activeModal.dismiss();
    this.widgetService
      .sendCloseWidget(this.settings.sessionId)
      .pipe(take(1))
      .subscribe();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
